import api from '@/api/axiosApi'

export interface StoreForecastEntryRead {
  id: string
  store_group_id: string
  store_group_name: string | null
  store_count: number
  allocation_percent: string | null
  total_forecast_units: number
  units_per_store: string | null
  units_per_store_per_week: string | null
}

export interface StoreForecastResponse {
  line_item_id: string
  total_sales_forecast: number | null
  num_stores: number | null
  weeks_in_plan: string | null
  items: StoreForecastEntryRead[]
}

export interface StoreForecastItemCreate {
  store_group_id: string
  total_forecast_units: number | null
  units_per_store: number | null
  units_per_store_per_week: number | null
}

export interface ReplaceStoreForecastRequest {
  items: StoreForecastItemCreate[]
}

export async function fetchStoreForecast(
  planId: string,
  versionId: string,
  lineId: string
): Promise<StoreForecastResponse> {
  const response = await api.get<StoreForecastResponse>(
    `/plans/${planId}/versions/${versionId}/lines/${lineId}/store-forecast`
  )
  return response.data
}

export async function saveStoreForecast(
  planId: string,
  versionId: string,
  lineId: string,
  body: ReplaceStoreForecastRequest
): Promise<StoreForecastResponse> {
  const response = await api.put<StoreForecastResponse>(
    `/plans/${planId}/versions/${versionId}/lines/${lineId}/store-forecast`,
    body
  )
  return response.data
}

export async function deleteStoreForecast(
  planId: string,
  versionId: string,
  lineId: string
): Promise<void> {
  await api.delete(
    `/plans/${planId}/versions/${versionId}/lines/${lineId}/store-forecast`
  )
}
